function IConSuccessComponent() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.2654 80.752L64.266 65.7276C63.291 64.75 61.7081 64.7482 60.7306 65.7231C60.2605 66.1921 59.9963 66.8286 59.9961 67.4926V102.516C59.9968 103.592 60.6856 104.546 61.706 104.886C61.9605 104.972 62.2272 105.016 62.4961 105.016C63.2828 105.016 64.0239 104.646 64.4959 104.016L79.4953 84.017C80.2408 83.0226 80.1428 81.6318 79.2654 80.752Z"
        fill="#8098F9"
      />
      <path
        d="M68.2862 75.1472L53.2868 70.1475C51.9774 69.7097 50.5609 70.4163 50.1231 71.7257C49.9516 72.239 49.9511 72.794 50.122 73.3074L60.1216 103.306C60.4622 104.329 61.4191 105.018 62.4964 105.016H62.6514C63.7808 104.946 64.7222 104.126 64.9463 103.016L69.946 78.0173C70.1979 76.7784 69.4855 75.5466 68.2862 75.1472Z"
        fill="#444CE7"
      />
      <path
        d="M118.923 5.49498C118.127 4.93789 117.08 4.89313 116.238 5.37991L21.2424 60.3777C20.0481 61.0703 19.6412 62.6 20.3338 63.7943C20.6398 64.3223 21.1285 64.7201 21.7074 64.9125L66.6054 79.8818L101.504 94.8411C102.774 95.3839 104.243 94.795 104.785 93.5254C104.861 93.3492 104.916 93.165 104.949 92.9763L119.948 7.97972C120.119 7.02281 119.719 6.05347 118.923 5.49498Z"
        fill="#6172F3"
      />
      <path
        d="M119.528 8.99492C120.335 7.87442 120.08 6.31214 118.96 5.50545C117.962 4.78712 116.589 4.90126 115.724 5.77497L50.5312 74.5321L69.3454 81.0318L119.528 8.99492Z"
        fill="#444CE7"
      />
      <path
        d="M6.10862 98.4911C5.48075 98.4918 4.87586 98.256 4.41369 97.8311C3.1671 96.6846 1.94043 95.5062 0.733916 94.2962C-0.243622 93.3201 -0.244794 91.7365 0.731338 90.7589C1.70747 89.7814 3.29108 89.7802 4.26862 90.7564C5.42849 91.9162 6.60852 93.0513 7.80355 94.1511C8.81976 95.0858 8.88585 96.6673 7.9512 97.6835C7.47708 98.1989 6.80867 98.4918 6.10862 98.4911Z"
        fill="#3538CD"
      />
      <path
        d="M40.1674 114.966C37.7586 114.958 35.3566 114.708 32.9977 114.221C31.6351 113.998 30.711 112.713 30.9339 111.35C31.1566 109.987 32.4418 109.063 33.8044 109.286C33.8693 109.297 33.934 109.31 33.9978 109.326C36.0328 109.746 38.1048 109.96 40.1824 109.966H40.1974H41.3224C42.6252 109.841 43.7825 110.797 43.907 112.099C43.9156 112.19 43.9189 112.28 43.9173 112.371C43.9679 113.75 42.8915 114.909 41.5125 114.961H40.2075L40.1674 114.966ZM22.2532 110.181C21.853 110.181 21.4588 110.085 21.1032 109.901C18.6457 108.615 16.2727 107.174 13.9984 105.586C12.8906 104.762 12.6604 103.196 13.4842 102.088C14.2705 101.031 15.7421 100.765 16.8483 101.481C18.9428 102.954 21.1306 104.29 23.3981 105.481C24.6241 106.116 25.1034 107.624 24.4685 108.85C24.0389 109.68 23.1825 110.201 22.2481 110.201L22.2532 110.181Z"
        fill="#3538CD"
      />
      <path
        d="M53.0202 112.286C51.6396 112.297 50.5113 111.187 50.5001 109.806C50.4919 108.797 51.0916 107.881 52.0204 107.486C53.4596 106.87 54.8574 106.162 56.2052 105.366C57.4113 104.694 58.9337 105.127 59.6056 106.333C60.2541 107.497 59.8756 108.965 58.7451 109.671C57.2118 110.577 55.6221 111.384 53.9853 112.086C53.68 112.216 53.3521 112.284 53.0202 112.286Z"
        fill="#3538CD"
      />
    </svg>
  );
}

export { IConSuccessComponent };
